import React, { useEffect } from 'react';

import { List, ListItem, ListItemAvatar, ListItemText, Collapse, TablePagination, Grid } from '@material-ui/core';
import CollapseIcon from '@material-ui/icons/ExpandMore';
import { StyledAvatar } from 'components/avatars';
import usePagination from 'screens/analytics/usePagination';
import styled, { css } from 'styled-components';
import { StyledDivider, StyledPaper, StyledButton, StyledTypography } from 'styles/common';

import theme from 'constants/theme';

const InvalidEmployeeList = ({ res, openedIndex, handleCollapse, index }) => {
  const { data, dataCount, rowsPerPage, pageNumber, setPageNumber, setData } = usePagination({
    rowsPerPageOptions: [],
    defaultRowsPerPage: 5,
    initialPage: 0,
  });

  useEffect(() => {
    setData(res.employees);
  }, []);

  return (
    <>
      {data && (
        <>
          <Collapse in={openedIndex === index} timeout="auto">
            <List>
              {data.map((employee) => (
                <ListItem key={employee.id}>
                  <Grid container alignItems="center">
                    <Grid item sm={4} container>
                      <ListItemAvatar>
                        <StyledAvatar
                          size="smallest"
                          alt={`${employee.displayName}'s pofile photo`}
                          src={employee.profilePhoto}
                        />
                      </ListItemAvatar>
                      <ListItemText primary={employee.displayName} />
                    </Grid>

                    <Grid item sm={8}>
                      <StyledTypography variant="body" customColor={theme.palette.text.label}>
                        {employee.designation}
                      </StyledTypography>
                    </Grid>
                  </Grid>
                </ListItem>
              ))}
            </List>
            <StyledDivider />
          </Collapse>
          <StyledPaper elevation={0} flexcontainer justifycontent="space-between">
            <StyledButton
              startIcon={<StyledCollapseIcon open={openedIndex === index} />}
              onClick={() => handleCollapse(index)}
            >
              {openedIndex === index ? 'Hide' : 'View'} employees
            </StyledButton>
            {openedIndex === index && (
              <TablePagination
                count={dataCount}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
                page={pageNumber}
                onChangePage={(e, newPage) => setPageNumber(newPage)}
              />
            )}
          </StyledPaper>
        </>
      )}
    </>
  );
};

const StyledCollapseIcon = styled(CollapseIcon)`
  ${(props) =>
    props.open &&
    css`
      transform: rotate(180deg);
    `}
`;

export default InvalidEmployeeList;
